import { BankAccountNewSection } from "bankaccount/BankAccountNewSection";
import BankAccountOptionsPanel from "bankaccount/edit/BankAccountOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

export const CreateBankAccountApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BankAccountNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BankAccountNewSection />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BankAccountOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            existingBankAccount={null}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}